import { logError } from 'commons/logger';
import { getActiveVariation } from '../../commons/abTest';
import { GET_AB_TESTS } from './queries';

export const resolvers = {
  Mutation: {},
  Query: {
    getClientABTest: (parent, { experimentName, refetch }, { cache }) => {
      try {
        const result = cache.readQuery({
          query: GET_AB_TESTS,
        });

        const abTests = result?.abTests || { experiments: [] };

        let data = abTests?.experiments.find(e => e.name === experimentName);

        if (data && !refetch) {
          return data;
        }

        const activeVariation = getActiveVariation(experimentName);

        if (!activeVariation) {
          return null;
        }

        if (data && data.variantName === activeVariation.name) {
          return data;
        }

        data = {
          name: experimentName,
          variantName: activeVariation.name || '',
          variantId: activeVariation.optimizeVariationId ?? 0,
          __typename: 'ClientABTest',
        };

        cache.writeQuery({
          query: GET_AB_TESTS,
          data: {
            abTests: {
              experiments: [...(abTests?.experiments ?? []), data],
              __typename: 'ClientABTests',
            },
          },
        });

        return data;
      } catch (err) {
        logError(err, 'Error processing getABTest client query');
        return null;
      }
    },
  },
};

export default resolvers;
